module.exports = __webpack_public_path__ + "static/media/Item 15.7b5525d6.jpg";